var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 198.647C0 88.9361 88.938 -0.00195312 198.649 -0.00195312C204.918 -0.00195312 210 5.08022 210 11.3494V189.998C210 201.044 201.046 209.998 190 209.998H11.3513C5.08217 209.998 0 204.916 0 198.647Z",
    fill: "#00ABB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerDecoration);
export default __webpack_public_path__ + "static/media/corner-decoration.b7d2fbe99534631a4786df96d05cea62.svg";
export { ForwardRef as ReactComponent };